import { InputAdornment } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React from "react";
import NumberFormat from "react-number-format";
import { getCardTypeImage } from "components/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    marginBottom: theme.spacing(2),
  },
}));

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      format="#### #### #### ####"
    />
  );
}

export default function MaskedCCInput(props) {
  const classes = useStyles();

  const { value, handleChange, helperText , error = "" } = props;
  const handleFocus = (event) => event.target.select();

  return (
    <div className={classes.root}>
      <TextField
        id="CreditCardNo"
        value={value}
        label="Card Number *"
        onFocus={handleFocus}
        onChange={handleChange("cardNumber")}
        fullWidth
        variant="outlined"
        error={error?.length > 0}
        helperText={error?.length > 0 ? error : ""}
        InputProps={{
          inputComponent: NumberFormatCustom,
          endAdornment: (
            <InputAdornment position="end">
              {getCardTypeImage(value)}
            </InputAdornment>
          ),
        }}
        className={classes.formControl}
        color="secondary"
        // required
      />
    </div>
  );
}
